/**
 * Recent-trades tape model. HL `trades` replays the last ~30 trades on every (re)subscribe, and the
 * replay arrives oldest first, so we merge by `tid` (unique per trade) and sort newest first.
 * `tid` is not monotonic, so ordering is by `time` (ties keep the higher tid first for stability).
 */
import type { Trade } from '../hl/types';

export const TAPE_CAP = 50;

export function mergeTrades(prev: readonly Trade[], incoming: readonly Trade[], cap = TAPE_CAP): Trade[] {
  if (incoming.length === 0) return prev as Trade[];
  const seen = new Set(prev.map((t) => t.tid));
  const fresh = incoming.filter((t) => {
    if (seen.has(t.tid)) return false;
    seen.add(t.tid);
    return true;
  });
  if (fresh.length === 0) return prev as Trade[];
  return [...fresh, ...prev].sort((a, b) => b.time - a.time || b.tid - a.tid).slice(0, cap);
}
